// extracted by mini-css-extract-plugin
export default {"link":"uA-z","disabled":"vA-z"};